import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4022216"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap select_none" }
const _hoisted_2 = { class: "mod_c_title hear" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hear_span" }, "授权设置", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "子直播间开启授权设置会覆盖全局设置的配置", -1))
const _hoisted_5 = {
  key: 1,
  class: "mod_wrap_tbody"
}
const _hoisted_6 = { class: "" }

import Crumb from '@/components/Crumb.vue';
// import { log } from '@antv/g2plot/lib/utils';
import { Tabs, Switch, Modal, message, Popover } from 'ant-design-vue';
import { computed, defineAsyncComponent, ref } from 'vue';
import { useStore } from 'vuex';
import routerid from '@/router';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import UploadImg from './UploadImg.vue';
import { useRoute } from 'vue-router';
import CLoading from '@/components/CLoading.vue';
import { QuestionCircleFilled } from '@ant-design/icons-vue';


// 授权观看父组件-----Authorization（授权）
const __default__ = { name: 'Authorization' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const liveBroadcastingRoomId = routerid.currentRoute.value.params.studioId;
// import http from '@/api/live';
const aSwitch = Switch;
const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const aModal = Modal;
const aPopover = Popover;
const PasswordWatch = defineAsyncComponent(() => import('./PasswordWatch.vue'));
const PayWatch = defineAsyncComponent(() => import('./PayWatch.vue'));
const WeChatLogin = defineAsyncComponent(() => import('./WeChatLogin.vue'));
const WhiteList = defineAsyncComponent(() => import('./WhiteList.vue'));
const UserWhiteList = defineAsyncComponent(() => import('./UserWhiteList.vue'));
const InviteWatch = defineAsyncComponent(() => import('./InviteWatch.vue'));
const IdentityGrant = defineAsyncComponent(() => import('./IdentityGrant.vue'));
const AnswerViewing = defineAsyncComponent(() => import('./AnswerViewing.vue'));
// const UploadImg1 = defineAsyncComponent(() => import('./UploadImg.vue'));
const getclosevalue = (data: any) => {
  openBgModel.value = data;
};
const mode = computed(() => store.state.authorizView.mode);
const activeKey = ref(0);
route.query.wx ? (activeKey.value = 2) : (activeKey.value = 0);
const store = useStore();
const checkref = ref(false);
const check = computed({
  get: () => store.state.authorizView.free,
  set: (val) => {
    checkref.value = val;
  },
});
const tabs = [
  {
    key: 0,
    title: '密码观看',
    component: PasswordWatch,
  },
  // {
  //   key: 1,
  //   title: '付费观看',
  //   component: PayWatch,
  // },
  {
    key: 2,
    title: '微信登录',
    component: WeChatLogin,
  },
  {
    key: 3,
    title: '手机白名单',
    component: WhiteList,
  },
  {
    key: 4,
    title: '观众白名单',
    component: UserWhiteList,
  },
  {
    key: 5,
    title: '邀约观看',
    component: InviteWatch,
  },
  {
    key: 6,
    title: '身份赋予',
    component: IdentityGrant,
  },
  {
    key: 7,
    title: '答题观看',
    component: AnswerViewing,
  },
];

const loading = computed(() => store.state.authorizView.showLoading);
const hideData = ref(false);
const setHide = () => {
  hideData.value = false;
};
const form = computed(() => store.state.authorizView.idView);
const getList = async () => {
  await store.dispatch('authorizView/getLiveView', liveBroadcastingRoomId);
};

const saveApi = async () => {
  try {
    const resMsg = await store.dispatch('authorizView/saveAothorize');
    form.value.authKey = await store.dispatch('authorizView/customAuthorization');
    message.destroy();
    message.success(resMsg);
  } catch (errMsg: any) {
    message.destroy();
    if (errMsg.code != 205) {
      message.error(errMsg.error as string);
    }
  }
};
const save = useDebounce(() => {
  message.destroy();
  store.commit('authorizView/checkSave');
  saveApi();
});
getList();
const updateSwitch = () => {
  store.commit('authorizView/updateSwitch', checkref.value);
};

const openBgModel = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(aSwitch), {
          class: "btns_txt",
          checked: _unref(check),
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => (_isRef(check) ? (check).value = $event : null)),
          onChange: updateSwitch
        }, null, 8, ["checked"]),
        (_unref(mode) === 4 || _unref(mode) === 5)
          ? (_openBlock(), _createBlock(_unref(aPopover), {
              key: 0,
              placement: "right"
            }, {
              content: _withCtx(() => [
                _hoisted_4
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(QuestionCircleFilled))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_button, {
          class: "background_img",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openBgModel.value = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("背景图设置")
          ]),
          _: 1
        })
      ]),
      (_unref(loading))
        ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(aTabs), {
              type: "card",
              activeKey: activeKey.value,
              "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((activeKey).value = $event)),
              onTabClick: setHide
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (item) => {
                  return _createVNode(_unref(aTabPane), {
                    key: item.key,
                    tab: item.title
                  }, {
                    default: _withCtx(() => [
                      (item.key === 7)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), {
                            key: 0,
                            modelValue: hideData.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((hideData).value = $event))
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), { key: 1 }))
                    ]),
                    _: 2
                  }, 1032, ["tab"])
                }), 64))
              ]),
              _: 1
            }, 8, ["activeKey"])
          ])),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_a_button, {
          type: "primary",
          class: "worp_but",
          onClick: _unref(save)
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 保存")
          ]),
          _: 1
        }, 8, ["onClick"])
      ], 512), [
        [_vShow, !hideData.value && !_unref(loading)]
      ]),
      _createVNode(_unref(aModal), {
        visible: openBgModel.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((openBgModel).value = $event)),
        title: "背景图片设置",
        width: "900px",
        footer: null,
        centered: "",
        class: "avatar_uploader_modal"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(UploadImg, { onGetclose: getclosevalue })
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})